
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.001 10.479c-4.972 0-9 .478-9 1.069s4.028 1.065 9 1.065 9-.477 9-1.065-4.027-1.069-9-1.069zm0 1.413c-1.172 0-2.124-.176-2.124-.393s.953-.392 2.124-.392 2.125.176 2.125.392-.954.393-2.125.393z"}}),_c('path',{attrs:{"d":"M7.892 5.254l.972 2.8 2.285-2.8h3.88c1.9 0 3.234.935 2.928 2.134s-2.118 2.134-4.01 2.134h-2.575s.058-.019.071-.055c.1-.41.7-2.726.706-2.761s-.044-.058-.044-.058h1.871s-.036 0-.051.058c-.01.034-.387 1.492-.468 1.816-.01.041-.067.061-.067.061h.447c1.061 0 2.065-.361 2.275-1.2.194-.762-.508-1.195-1.652-1.195h-2.2l-4.108 4.327-1.573-4.244a.607.607 0 01-.026-.064.072.072 0 00-.081-.028.065.065 0 00-.027.063.162.162 0 01.019.049 1.556 1.556 0 01.135 1.1c-.317 1.2-2.121 2.133-4.013 2.133H.005s.061-.019.07-.055c.1-.412.7-2.739.707-2.762.007-.039-.041-.058-.041-.058h1.885s-.054.016-.064.057-.391 1.492-.471 1.817c-.01.04-.073.061-.073.061h.458c1.063 0 2.058-.36 2.268-1.2.193-.762-.5-1.195-1.645-1.195H.861s.051-.026.06-.061c.05-.193.2-.8.211-.826s-.044-.056-.044-.056z"}})])
          )
        }
      }
    